module.exports = __webpack_public_path__ + "img/liangguangzhenxingdaiWu.min.5ca44c06.png";